export default __webpack_public_path__ + "static/media/G0160-Figure_5.17_BAPM.1711619160000.582cf10c.jpg";